(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["etkinlik-takvimi-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var STORAGE_KEY = 'chora-etkinlik-popup-shown';

    function init() {
      var popup = document.querySelector('.etkinlik-popup');
      if (!popup) return;
      if (sessionStorage.getItem(STORAGE_KEY)) return;

      popup.hidden = false;
      requestAnimationFrame(function () {
        popup.classList.add('etkinlik-popup--visible');
      });

      function closePopup() {
        popup.classList.remove('etkinlik-popup--visible');
        setTimeout(function () {
          popup.hidden = true;
        }, 250);
        sessionStorage.setItem(STORAGE_KEY, '1');
      }

      popup.querySelectorAll('[data-etkinlik-popup-close]').forEach(function (el) {
        el.addEventListener('click', closePopup);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !popup.hidden) closePopup();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
